import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AppNotificationInterface } from '../models/app-notification.interface';
import { State } from './core-store.state';

const getAppNotifications = (state: State): Array<AppNotificationInterface> =>
  state.appNotifications;

export const selectCoreState = createFeatureSelector<State>('core');

export const selectAppNotifications = createSelector(
  selectCoreState,
  getAppNotifications,
);
